import React, { Component } from 'react';
import { SVGIcon, Drawer } from 'react-md';
import NavigationDrawer from 'react-md/lib/NavigationDrawers';
import CloseButton from 'react-md/lib/NavigationDrawers/CloseButton';
import GetNavList from './NavList';
import Footer from '../Footer/Footer';
import "./Navigation.scss";

//import WeatherBtn from '../WeatherBtn/WeatherBtn'

const DrawerHeaderComponent = props => (<div {...props}>
                                          <CloseButton className="cr-close-drawer-btn" />
                                        </div>)

const HambIcon = () => (<SVGIcon size={28}>
                          <g id="hamb" fill="#ffffff">
                              <polygon id="Path" points="0 17 28 17 28 14 0 14"></polygon>
                              <polygon id="Path" points="0 10 28 10 28 7 0 7"></polygon>
                              <polygon id="Path" points="0 3 28 3 28 0 0 0"></polygon>
                          </g>
                        </SVGIcon>)

class Navigation extends Component {
  render() {
    const { children, config, LocalTitle } = this.props;
    const footerLinks = LocalTitle !== "About";
    return (
      <NavigationDrawer
        desktopDrawerType={Drawer.DrawerTypes.PERSISTENT}
        drawerZDepth={0}
        drawerClassName="cr-drawer md-grid md-grid--no-spacing"
        //drawerHeader={<DrawerHeaderComponent className="md-cell md-cell--12" />}
        contentClassName="cr-main-content"
        toolbarTitleClassName="cr-toolbar-title"
        toolbarClassName="cr-toolbar"
        toolbarZDepth={0}
        toolbarTitle={LocalTitle}
        temporaryIcon={<HambIcon />}
        navClassName="cr-nav md-cell md-cell--12"
        className="cr-navigation"
        navItems={GetNavList(config)} >
        <div className="cr-background"></div>
        {children}
        <Footer />
      </NavigationDrawer>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js